export default {
  init() {

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/fusionframe.js